import { render, staticRenderFns } from "./PaxInfoView.vue?vue&type=template&id=78077cfe&"
import script from "./PaxInfoView.vue?vue&type=script&lang=js&"
export * from "./PaxInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports